import PersonIcon from '@mui/icons-material/Person'
import SettingsIcon from '@mui/icons-material/Settings'
import BookIcon from '@mui/icons-material/MenuBook'
import ExploreIcon from '@mui/icons-material/Explore'
import BubbleIcon from '@mui/icons-material/BubbleChart'
import HistoryIcon from '@mui/icons-material/History'
import HotIcon from '@mui/icons-material/Whatshot'

const NavigationCategories = [
    {
        id: 'Main',
        menu: false,
        icon: <HotIcon />,
        path:'/',
        view: {
            title: 'Top of the Mind',
            subtext: '',
        },
        children : [
            { 
                id: 'Login',
                icon: null,
                path:'/login',
                view: {
                    title: 'User Login',
                    subtext: 'Show me your papers',
                },
            },
            { 
                id: 'Sign Up',
                icon: null,
                path:'/signup',
                view: {
                    title: 'Create an Account',
                    subtext: 'Pensieve will help calm the brain storm',
                },
            },
            { 
                id: 'Help',
                icon: null,
                path:'/help',
                view: {
                    title: 'Help',
                    subtext: "Get Instructions on the usage of Pensieve's functionalities",
                },
            },
        ],
    },
    {
        id: 'User',
        menu: true,
        icon: null,
        view: null,
        children : [
            { 
                id: 'Profile',
                icon: <PersonIcon />,
                path:'/profile',
                view: {
                    title: 'User Profile',
                    subtext: 'Change your Bio, Avatar and Public Info',
                }
            },
            { 
                id: 'Settings',
                icon: <SettingsIcon />,
                path:'/settings',
                view: {
                    title: 'User Settings',
                    subtext: 'Change your Defaults, Privacy, Notifications and Themes',
                },
            },
        ],
    },
    {
        id: 'Topics',
        menu: true,
        icon: null,
        view: null,
        children : [
            {
                id: 'Author',
                icon: <BookIcon />,
                path:'/topic',
                view: {
                    title: 'Author a Topic',
                    subtext: 'Create and Edit your own understanding of a Topic and its relations',
                },
            },
            {
                id: 'Explore',
                icon: <ExploreIcon />,
                path:'/explore',
                view: {
                    title: 'Explore Topics',
                    subtext: 'Browse the collectively created Topic Graph',
                },
            },
        ],
    },
    {
        id: 'Thoughts',
        menu: true,
        icon: null,
        view: null,
        children : [
            {
                id: 'Navigate',
                icon: <BubbleIcon />,
                path:'/mind',
                view: {
                    title: 'Navigate Thoughts',
                    subtext: 'Explore your previous Thoughts and bring them to the Top',
                },
            },
            {
                id: 'Timeline',
                icon: <HistoryIcon />,
                path:'/timeline',
                view: {
                    title: 'User Timeline',
                    subtext: 'Take a look back and see how you got here',
                },
            },
        ],
    },
]

export default NavigationCategories;
